

export const mapScore = (Pipe) => {
    const pipes = Pipe.pipes
    const x = Pipe.x;
    const passedChallenges = pipes
      .map(({ topHeight }, i) => {
        return {
          x1: x + i * 200,
          y1: topHeight,
          x2: x + i * 200,
          y2: topHeight + 100,
        };
      }).filter(({ x1 }) => {
        if (x1 < 0) {
          return true;
        }
        return false;
      });

    return passedChallenges.length;
  };